import { render, staticRenderFns } from "./JEllipsis.vue?vue&type=template&id=533eaba5&scoped=true"
import script from "./JEllipsis.vue?vue&type=script&lang=js"
export * from "./JEllipsis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533eaba5",
  null
  
)

export default component.exports